@use '../../sass/theme';
@use '../../sass/loader';

:host {
  appearance: unset !important;
}
:host([disabled]) {
  pointer-events: none;
  touch-action: none;
}
:host([disabled='false']) {
  pointer-events: auto;
  touch-action: auto;
}

$variants: primary, secondary, success, info, warning, danger, low, high;

@mixin get-variants() {
  @each $variant in $variants {
    &.#{$variant} {
      background-color: var(--jui-#{$variant}-color);
      border-color: var(--jui-#{$variant}-color);
    }
  }
}

.progress-stepper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: transparent;
  font-family: var(--jui-font-family);

  &.xs {
    font-size: 0.7rem;
  }

  &.sm {
    font-size: 0.8rem;
  }

  &.md {
    font-size: 1rem;
  }

  &.lg {
    font-size: 1.1rem;
  }

  &.xl {
    font-size: 1.25rem;
  }

  &__steps {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
  }

  &__step {
    position: relative;
    flex-grow: 1;
    align-items: center;
    border-radius: 10px;
    height: 7px;
    margin-left: var(--jds-space-xs);
    margin-right: var(--jds-space-xs);
    background-color: var(--jds-base-grey-500);

    &:first-of-type {
      margin-left: 0;
    }

    &:last-of-type {
      margin-right: 0;
    }

    &.xs {
      height: 0.1rem;
    }

    &.sm {
      height: 0.3rem;
    }

    &.md {
      height: 0.5rem;
    }

    &.lg {
      height: 0.7rem;
    }

    &.xl {
      height: 1rem;
    }

    &--active {
      @include get-variants;
    }
  }
}
